import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query'
import {HTTP_STATUS_OK} from '../../../Constants'
import {QueryKeyTypes} from '../../../query-manager/QueryKeyTypes'
import {
    QueryCRUDTypes,
    QueryKeyManager,
} from '../../../query-manager/QueryKeysManager'
import {severityNotification} from '../../notification/NotificationConstant'
import {showNotification} from '../../notification/NotificationService'
import {addPatientToPathway} from '../../user-property/UserPropertyEndPoint'
import {
    createOrUpdatePathway,
    deletePathway,
    getListPathways,
    getPagePathways,
} from '../PathwayEndPoint'

export const useListPathways = (
    requestorId,
    simple = false,
    filterRequest = {},
    enabled = true,
) => {
    const {pathwayKeys} = QueryKeyManager(QueryKeyTypes.pathway, requestorId)
    return useQuery({
        queryKey: pathwayKeys.list({simple, filterRequest}),
        queryFn: () => getListPathways(requestorId, simple, filterRequest),
        enabled: !!requestorId && !!enabled,
    })
}

export const usePagePathways = (
    requestorId,
    pageNumber,
    pageRows,
    sortField,
    sortOrder,
    filterRequest,
    enabled = true,
) => {
    const {pathwayKeys} = QueryKeyManager(QueryKeyTypes.pathway, requestorId)

    return useQuery({
        queryKey: pathwayKeys.page({
            pageNumber,
            pageRows,
            sortField,
            sortOrder,
            filterRequest,
        }),
        queryFn: () =>
            getPagePathways(
                requestorId,
                pageNumber,
                pageRows,
                sortField,
                sortOrder,
                filterRequest,
            ),
        enabled: !!requestorId && !!enabled,
    })
}

export const usePathwayCRUD = (type, requestorId) => {
    const {pathwayKeys} = QueryKeyManager(QueryKeyTypes.pathway, requestorId)
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: data =>
            type === QueryCRUDTypes.create || type === QueryCRUDTypes.update
                ? createOrUpdatePathway(requestorId, data)
                : type === QueryCRUDTypes.delete
                ? deletePathway(requestorId, data?.id)
                : data,
        onSuccess: (data, variables) => {
            // Data is the response from the server
            // Variables is the data that was passed to the mutationFn
            if (data === HTTP_STATUS_OK || data?.id) {
                if (
                    type === QueryCRUDTypes.create ||
                    type === QueryCRUDTypes.update
                ) {
                    showNotification(
                        severityNotification.success,
                        'Pathway Update Successfully !!',
                    )
                } else if (type === QueryCRUDTypes.delete) {
                    showNotification(
                        severityNotification.success,
                        'Deletion performed successfully!!',
                    )
                }
            }
        },
    })
}

export const usePathwayAssignment = requestorId => {
    return useMutation({
        mutationFn: data => addPatientToPathway(requestorId, data),
        onSuccess: (data, variables) => {
            // Data is the response from the server
            // Variables is the data that was passed to the mutationFn
            if (data === HTTP_STATUS_OK || data?.id) {
                showNotification(
                    severityNotification.success,
                    'Patients assigned to pathway successfully !!',
                )
            }
        },
    })
}

export const useSupportTeamAssignment = requestorId => {
    return useMutation({
        mutationFn: data => addPatientToPathway(requestorId, data),
        onSuccess: (data, variables) => {
            // Data is the response from the server
            // Variables is the data that was passed to the mutationFn
            if (data === HTTP_STATUS_OK || data?.id) {
                showNotification(
                    severityNotification.success,
                    'Patients assigned to Support Team successfully !!',
                )
            }
        },
    })
}
